<template>
  <section class="hero">
    <div class="hero-content">
      <div class="hero-text animate-fade-in">
        <h1>
          <span class="gradient-text">AI-Powered</span> Sales Automation
          <span class="typing-cursor">|</span>
        </h1>
        <p class="hero-subtitle">
          Transform your sales processes with AI-powered lead generation and outreach automation. 
          <span class="highlight">Triple your sales performance</span> with intelligent automation.
        </p>
      </div>
      
      <div class="cta-group animate-slide-up">
        <button class="primary-cta pulse" @click="startTrial">
          <span>Try Free for 14 Days</span>
          <span class="arrow">→</span>
        </button>
        <button class="secondary-cta" @click="showDemo">
          <span class="play-icon">▶</span>
          Watch Demo
        </button>
      </div>

      <div class="metrics-banner animate-fade-in">
        <div class="metric">
          <div class="metric-number counter">2.5x</div>
          <div class="metric-label">More Leads</div>
        </div>
        <div class="divider"></div>
        <div class="metric">
          <div class="metric-number counter">70%</div>
          <div class="metric-label">Time Saved</div>
        </div>
        <div class="divider"></div>
        <div class="metric">
          <div class="metric-number counter">3M+</div>
          <div class="metric-label">Leads Generated</div>
        </div>
      </div>

      <div class="social-proof">
        <p class="trust-text">Trusted by leading companies worldwide</p>
        <div class="logos animate-slide-up">
          <img 
            v-for="logo in clientLogos" 
            :key="logo.id"
            :src="logo.src" 
            :alt="logo.alt" 
            class="logo-item"
          >
        </div>
      </div>
    </div>

    <!-- Floating Elements -->
    <div class="floating-elements">
      <div class="floating-card card1">
        <span class="icon">📈</span>
        <span>Lead Generation</span>
      </div>
      <div class="floating-card card2">
        <span class="icon">🤖</span>
        <span>AI Automation</span>
      </div>
      <div class="floating-card card3">
        <span class="icon">📊</span>
        <span>Analytics</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      clientLogos: [
        {
          id: 1,
          src: `data:image/svg+xml;base64,${btoa(`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 50">
              <g fill="#666">
                <path d="M30 15c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"/>
                <path d="M45 20c0-8.3-6.7-15-15-15s-15 6.7-15 15c0 7.5 5.5 13.7 12.7 14.9v-10.4c-1.7.5-3.5-.5-4-2.2-.5-1.7.5-3.5 2.2-4 1.7-.5 3.5.5 4 2.2.3 1.1 0 2.2-.7 3v10.4c7.2-1.2 12.8-7.4 12.8-14.9z"/>
                <text x="60" y="28" font-family="Arial" font-size="14">Salesforce</text>
              </g>
            </svg>
          `)}`,
          alt: 'Salesforce Logo'
        },
        {
          id: 2,
          src: `data:image/svg+xml;base64,${btoa(`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 50">
              <g fill="#666">
                <circle cx="25" cy="25" r="10"/>
                <circle cx="45" cy="25" r="10"/>
                <path d="M35 15c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10z"/>
                <text x="65" y="28" font-family="Arial" font-size="14">HubSpot</text>
              </g>
            </svg>
          `)}`,
          alt: 'HubSpot Logo'
        },
        {
          id: 3,
          src: `data:image/svg+xml;base64,${btoa(`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 50">
              <g fill="#666">
                <path d="M20 15h10v20H20z"/>
                <path d="M35 15h10v20H35z"/>
                <circle cx="32.5" cy="25" r="12.5"/>
                <text x="60" y="28" font-family="Arial" font-size="14">ZoomInfo</text>
              </g>
            </svg>
          `)}`,
          alt: 'ZoomInfo Logo'
        }
      ],
      trustBadges: [
        { id: 1, number: '500+', label: 'Active Clients' },
        { id: 2, number: '98%', label: 'Client Satisfaction' },
        { id: 3, number: '3M+', label: 'Leads Generated' },
      ]
    }
  },
  methods: {
    startTrial() {
      // Trial başlatma mantığı
      console.log('Trial started')
    },
    showDemo() {
      // Demo gösterme mantığı
      console.log('Show demo')
    }
  }
}
</script>

<style scoped>
.hero {
  padding: 8rem 2rem 6rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}

.hero::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url('../assets/pattern.svg') repeat;  /* Relative path kullanıyoruz */
  opacity: 0.1;
  pointer-events: none;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.hero-text {
  position: relative;
  margin-bottom: 3rem;
}

.gradient-text {
  background: linear-gradient(45deg, #2563eb, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
}

.typing-cursor {
  animation: blink 1s infinite;
  color: var(--primary-color);
}

.highlight {
  background: linear-gradient(120deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.1) 100%);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
}

.hero-subtitle {
  font-size: 1.35rem;
  color: #4b5563;
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.6;
}

.cta-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 3rem;
}

.primary-cta,
.secondary-cta {
  padding: 1rem 2rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  font-size: 1.125rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.primary-cta {
  background: var(--primary-color);
  color: white;
  border: none;
}

.secondary-cta {
  background: white;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}

.metrics-banner {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin: 3rem auto;
  max-width: 800px;
}

.metric {
  text-align: center;
  padding: 0 2rem;
}

.metric-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}

.metric-label {
  color: #6b7280;
  font-size: 0.9rem;
}

.divider {
  width: 1px;
  height: 50px;
  background: #e5e7eb;
}

.social-proof {
  margin-top: 4rem;
}

.social-proof > p {
  color: #6b7280;
  margin-bottom: 2rem;
}

.logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5rem;
  margin: 3rem 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: var(--border-radius);
}

.logo-item {
  height: 50px;
  opacity: 0.7;
  transition: all 0.3s ease;
  filter: grayscale(100%);
}

.logo-item:hover {
  opacity: 1;
  filter: grayscale(0%);
  transform: scale(1.05);
}

.trust-badges {
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin-top: 3rem;
}

.badge {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.badge .number {
  font-size: 2rem;
  font-weight: 700;
  color: var(--primary-color);
}

.badge .label {
  font-size: 0.9rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

.trust-text {
  color: #6b7280;
  margin-bottom: 2rem;
}

/* Floating Cards */
.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.floating-card {
  position: absolute;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  animation: float 3s infinite ease-in-out;
}

.card1 {
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.card2 {
  top: 40%;
  right: 10%;
  animation-delay: 2s;
}

.card3 {
  bottom: 20%;
  left: 15%;
  animation-delay: 4s;
}

/* Enhanced CTA Buttons */
.primary-cta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
  position: relative;
}

.primary-cta .arrow {
  transition: transform 0.3s ease;
}

.primary-cta:hover .arrow {
  transform: translateX(5px);
}

.secondary-cta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.play-icon {
  font-size: 0.8rem;
}

/* Animations */
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.animate-fade-in {
  animation: fadeIn 1s ease-out;
}

.animate-slide-up {
  animation: slideUp 0.8s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero {
    padding: 6rem 1rem 4rem;
  }

  .hero-content {
    padding: 0 1rem;
  }

  h1 {
    font-size: 2.75rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
    padding: 0 1rem;
  }

  .trust-badges {
    flex-direction: column;
    gap: 1.5rem;
  }

  .logos {
    flex-wrap: wrap;
    gap: 1.5rem;
  }

  .cta-group {
    flex-direction: column;
    gap: 1rem;
    padding: 0 1rem;
  }

  .primary-cta,
  .secondary-cta {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }

  .metrics-banner {
    margin: 3rem 1rem;
    padding: 1.5rem;
    flex-direction: column;
    gap: 2rem;
  }

  .divider {
    width: 50px;
    height: 1px;
  }

  .floating-elements {
    display: none;
  }
}
</style> 